enum AppointmentContactChannel {
    Unknown = 0,
    Email = 1,
    Sms = 2,
    Phone = 3
}

export { AppointmentContactChannel };
